import {createSelector} from '@ngrx/store';
import VideoState from '../video.state';

export const selectState = (state: { video: VideoState }) => state;

export const selectOverlays = createSelector(
    selectState,
    (state: { video: VideoState }) => state.video.overlays
);

export const selectForms = createSelector(
    selectState,
    (state: { video: VideoState }) => state.video.forms
);

export const selectImagesPreloaded = createSelector(
    selectState,
    (state: { video: VideoState }) => state.video.imagesPreloaded
);
